// Reader formats
export const readerTypes = [
  {
    formatId: 1,
    formatType: 'CDAuto',
    label: 'Clock & Data',
    hasSize: true,
    minSize: 5,
    maxSize: 13,
    encoding: 'Decimal',
    dataType: 'digits',
    compatible: [2],
  },
  {
    formatId: 2,
    formatType: 'CDCustom',
    label: 'Clock & Data personnalisé',
    hasSize: true,
    minSize: 8,
    maxSize: 128,
    hasCardNumber: true,
    cardNumberMinSize: 5,
    cardNumberMaxSize: 13,
    encoding: 'Decimal',
    dataType: 'digits',
    compatible: [1,2],
  },
  {
    formatId: 3,
    formatType: 'WAuto',
    label: 'Wiegand',
    hasSize: true,
    minSize: 16,
    maxSize: 64,
    dataType: 'bits',
    compatible: [5,6,7,8,9,10,11,12,14,18,19],
  },
  {
    formatId: 4,
    formatType: 'WAuto',
    label: 'Wiegand décimal',
    hasSize: true,
    minSize: 16,
    maxSize: 56,
    encoding: 'Decimal',
    dataType: 'bits',
    compatible: [5,6,7,8,9,10,11,12,14,18,19],
  },
  {
    formatId: 5,
    formatType: 'WCustom',
    hasIdentifierType: true,
    label: 'Wiegand 26 bits avec code site',
    config: {
      'size': 26,
      'card_number': { 'start': 10, 'end': 25 },
      'facility_code': { 'start': 2, 'end': 9 },
      'parities': [
        { 'start': 1, 'end': 13, 'parity_type': 'Even' },
        { 'start': 14, 'end': 26, 'parity_type': 'Odd' },
      ],
    },
    compatible: [3,4,6,7,8,9,10,11,12,14,18,19],
  },
  {
    formatId: 6,
    formatType: 'WCustom',
    hasIdentifierType: true,
    label: 'Wiegand 26 bits sans code site',
    config: {
      'size': 26,
      'card_number': { 'start': 10, 'end': 25 },
      'parities': [
        { 'start': 1, 'end': 13, 'parity_type': 'Even' },
        { 'start': 14, 'end': 26, 'parity_type': 'Odd' },
      ],
    },
    compatible: [3,4,5,7,8,9,10,11,12,14,18,19],
  },
  {
    formatId: 7,
    formatType: 'WCustom',
    hasIdentifierType: true,
    label: 'Wiegand 32 bits',
    config: {
      'size': 32,
      'card_number': { 'start': 1, 'end': 32 },
    },
    compatible: [3,4,5,6,8,9,10,11,12,14,18,19],
  },
  {
    formatId: 8,
    formatType: 'WCustom',
    hasIdentifierType: true,
    label: 'Wiegand 56 bits',
    config: {
      'size': 56,
      'card_number': { 'start': 1, 'end': 56 },
    },
    compatible: [3,4,5,6,7,9,10,11,12,14,18,19],
  },
  {
    formatId: 9,
    formatType: 'WCustom',
    hasIdentifierType: true,
    label: 'Wiegand personnalisé',
    hasSize: true,
    minSize: 16,
    maxSize: 128,
    hasCardNumber: true,
    cardNumberMinSize: 16,
    cardNumberMaxSize: 64,
    hasFacilityCode: true,
    facilityCodeMinSize: 8,
    facilityCodeMaxSize: 32,
    hasParities: true,
    dataType: 'bits',
    compatible: [3,4,5,6,7,8,9,10,11,12,14,18,19],
  },
  {
    formatId: 10,
    formatType: 'WCustom',
    hasIdentifierType: true,
    label: 'Wiegand décimal personnalisé',
    hasSize: true,
    minSize: 16,
    maxSize: 128,
    hasCardNumber: true,
    cardNumberMinSize: 16,
    cardNumberMaxSize: 56,
    hasFacilityCode: true,
    facilityCodeMinSize: 8,
    facilityCodeMaxSize: 32,
    hasParities: true,
    encoding: 'Decimal',
    dataType: 'bits',
    compatible: [3,4,5,6,7,8,9,10,11,12,14,18,19],
  },
  {
    formatId: 11,
    formatType: 'WCustom',
    label: 'Wiegand 30 bits VKP',
    config: {
      'size': 30,
      'card_number': { 'start': 2, 'end': 29 },
    },
    compatible: [3,4,5,6,7,8,9,10,12,14,18,19],
  },
  {
    formatId: 12,
    formatType: 'WCustom',
    label: 'Wiegand HAXO SCAN',
    config: {
      'size': 56,
      'card_number': { 'start': 1, 'end': 56 },
    },
    compatible: [3,4,5,6,7,8,9,10,11,14,18,19],
  },
  {
    // OSDP reader detecting Haxo secure QR codes in its ASCII reads
    formatId: 13,
    formatType: 'OSDP',
    label: 'HAXO SECURE',
    is_rs485: true,
    hasKeypad: true,
    config: {
      'haxo_scan': true,
    },
    compatible: [13],
  },
  {
    formatId: 14,
    formatType: 'WCustom',
    hasIdentifierType: true,
    label: 'Wiegand 34 bits',
    config: {
      'size': 34,
      'card_number': {'start': 2, 'end': 33},
      'parities': [
        {'start': 1, 'end': 17, 'parity_type': 'Even'},
        {'start': 18, 'end': 34, 'parity_type': 'Odd'},
      ],
    },
    compatible: [3,4,5,6,7,8,9,10,11,12,18,19],
  },
  {
    formatId: 15,
    formatType: 'SSCP',
    label: 'SSCP V2',
    is_rs485: true,
    has_rgb_leds: true,
    has_ble: true,
    compatible: [15],
  },
  {
    formatId: 16,
    formatType: 'OSDP',
    label: 'OSDP',
    is_rs485: true,
    hasKeypad: true,
    compatible: [16],
  },
  {
    formatId: 17,
    formatType: 'RS485',
    label: 'RS485',
    compatible: [],
  },
  {
    // Keypad-only reader : the frames are codes, the entry length is configurable
    formatId: 18,
    formatType: 'WCustom',
    label: 'Wiegand Clavier 4 bits',
    hasKeypad: true,
    identifierType: 'code',
    config: {
      'size': 4,
    },
    compatible: [3,4,5,6,7,8,9,10,11,14,19],
  },
  {
    formatId: 19,
    formatType: 'WCustom',
    label: 'Wiegand Clavier 8 bits',
    hasKeypad: true,
    identifierType: 'code',
    config: {
      'size': 8,
    },
    compatible: [3,4,5,6,7,8,9,10,11,14,18],
  },
];

/** Identifier type imposed by the reader type ('unknown' when absent or chosen by the installer) */
export function defaultIdentifierType(formatId) {
  return readerTypes.find(type => type.formatId === formatId)?.identifierType ?? 'unknown';
}
